"use client";

import { ReactNode } from "react";
import { useForm, FormProvider as HookFormProvider } from "react-hook-form";

type FormProviderProps = Parameters<typeof useForm>[0] & {
  children: ReactNode;
};

const FormProvider = ({ children, ...props }: FormProviderProps) => {
  const context = useForm(props);
  return <HookFormProvider {...context}>{children}</HookFormProvider>;
};

export default FormProvider;
